import styled from "styled-components";

export const VerificationSuccessStyled = styled.div`
  width: 100%;
  padding: 0px 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px); // 레이아웃 위아래 패딩 30px 제거

  .success_container {
    width: 100%;
  }

  .logo_text {
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    text-align: center;
  }

  .desc_text {
    color: #666;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }

  .desc_text_02 {
    color: #666;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }
`;
